import { render, staticRenderFns } from "./ImportLogReport.vue?vue&type=template&id=1835ca67"
import script from "./ImportLogReport.vue?vue&type=script&lang=js"
export * from "./ImportLogReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports